import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-schedule-message-modal',
    templateUrl: './schedule-message-modal.component.html',
    styleUrls: ['./schedule-message-modal.component.scss'],
    standalone: false
})
export class ScheduleMessageModalComponent implements OnInit {
    public onClose: Subject<Date | null> = new Subject();
    
    public selectedDate: Date;
    public selectedTime: string;
    public timeOptions: Array<{ label: string; value: string }> = [];
    public minDate: Date = new Date();
    
    constructor(public bsModalRef: BsModalRef) {}

    ngOnInit(): void {
        // Generate time options in 15-minute intervals
        this.generateTimeOptions();

        // If initial values were not provided via initialState, use defaults
        if (!this.selectedDate) {
            this.selectedDate = new Date();
        }

        if (!this.selectedTime) {
            this.setNextFullHour();
        }
    }

    private generateTimeOptions(): void {
        const options: Array<{ label: string; value: string }> = [];
        
        for (let hour = 0; hour < 24; hour++) {
            for (let minute = 0; minute < 60; minute += 15) {
                const time24 = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
                const date = new Date();
                date.setHours(hour, minute, 0, 0);
                
                // Format as 12-hour with AM/PM
                const hours12 = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
                const ampm = hour >= 12 ? 'PM' : 'AM';
                const label = `${hours12.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')} ${ampm}`;
                
                options.push({ label, value: time24 });
            }
        }
        
        this.timeOptions = options;
    }

    private setNextFullHour(): void {
        const now = new Date();
        const nextHour = new Date(now);
        nextHour.setHours(now.getHours() + 1, 0, 0, 0);
        
        // Format as HH:mm
        const hours = nextHour.getHours().toString().padStart(2, '0');
        this.selectedTime = `${hours}:00`;
    }

    public getTimezoneInfo(): string {
        return `The message will be scheduled in your current timezone.`;
    }

    public schedule(): void {
        if (!this.selectedDate || !this.selectedTime) {
            return;
        }

        // Combine date and time in user's local timezone
        const scheduledDateTime = new Date(this.selectedDate);
        const [hours, minutes] = this.selectedTime.split(':').map(Number);
        scheduledDateTime.setHours(hours, minutes, 0, 0);

        // Ensure the date is not in the past
        const now = new Date();
        if (scheduledDateTime <= now) {
            // If selected time is in the past, move to next day
            scheduledDateTime.setDate(scheduledDateTime.getDate() + 1);
        }

        this.onClose.next(scheduledDateTime);
        this.bsModalRef.hide();
    }

    public cancel(): void {
        this.onClose.next(null);
        this.bsModalRef.hide();
    }

}
